mutation CreateGiveaway(
  $eventId: ID!
  $name: String!
  $broadcasterUserIds: [String!]!
  $entryCommand: String!
  $winnerCount: Int!
  $alternateCount: Int!
  $excludeBroadcaster: Boolean!
  $excludeModerators: Boolean!
  $rulesUrl: String!
  $sponsorName: String!
  $prizeName: String!
  $prizeImageUrl: String
  $brandLogoUrl: String
  $brandText: String
  $backgroundImage: String
  $backgroundImageFit: String
  $titleText: String
  $openCtaText: String
  $entrantsLabel: String
  $openFooterText: String
  $upcomingHeadline: String
  $upcomingCtaText: String
  $closedHeadline: String
  $closedSubhead: String
  $closedBody: String
  $closedFooterText: String
  $endedHeadline: String
  $congratsText: String
  $endedFooterText: String
  $rulesLabel: String
  $legalText: String
  $textColor: String!
  $background: String!
  $borderColor: String!
  $borderWidth: Int!
  $cornerRadius: Int!
  $winnerOutlineColor: String!
  $accentBackground: String!
  $accentTextColor: String!
  $titleFontKey: String!
  $textFontKey: String!
  $captionFontKey: String!
  $subtitleFontKey: String!
  $prizeImageRadius: Int!
  $prizeImageBorderWidth: Int!
  $prizeImageBorderColor: String!
  $prizeImageWidthPx: Int!
  $countDividerEnabled: Boolean!
  $countDividerColor: String!
  $countDividerWidthPx: Int!
  $brandDividerEnabled: Boolean
  $brandDividerColor: String!
  $brandDividerWidthPx: Int!
) {
  giveaway: StreamToolsCreateGiveaway(
    eventId: $eventId
    name: $name
    broadcasterUserIds: $broadcasterUserIds
    entryCommand: $entryCommand
    winnerCount: $winnerCount
    alternateCount: $alternateCount
    excludeBroadcaster: $excludeBroadcaster
    excludeModerators: $excludeModerators
    rulesUrl: $rulesUrl
    sponsorName: $sponsorName
    prizeName: $prizeName
    prizeImageUrl: $prizeImageUrl
    brandLogoUrl: $brandLogoUrl
    brandText: $brandText
    backgroundImage: $backgroundImage
    backgroundImageFit: $backgroundImageFit
    titleText: $titleText
    openCtaText: $openCtaText
    entrantsLabel: $entrantsLabel
    openFooterText: $openFooterText
    upcomingHeadline: $upcomingHeadline
    upcomingCtaText: $upcomingCtaText
    closedHeadline: $closedHeadline
    closedSubhead: $closedSubhead
    closedBody: $closedBody
    closedFooterText: $closedFooterText
    endedHeadline: $endedHeadline
    congratsText: $congratsText
    endedFooterText: $endedFooterText
    rulesLabel: $rulesLabel
    legalText: $legalText
    textColor: $textColor
    background: $background
    borderColor: $borderColor
    borderWidth: $borderWidth
    cornerRadius: $cornerRadius
    winnerOutlineColor: $winnerOutlineColor
    accentBackground: $accentBackground
    accentTextColor: $accentTextColor
    titleFontKey: $titleFontKey
    textFontKey: $textFontKey
    captionFontKey: $captionFontKey
    subtitleFontKey: $subtitleFontKey
    prizeImageRadius: $prizeImageRadius
    prizeImageBorderWidth: $prizeImageBorderWidth
    prizeImageBorderColor: $prizeImageBorderColor
    prizeImageWidthPx: $prizeImageWidthPx
    countDividerEnabled: $countDividerEnabled
    countDividerColor: $countDividerColor
    countDividerWidthPx: $countDividerWidthPx
    brandDividerEnabled: $brandDividerEnabled
    brandDividerColor: $brandDividerColor
    brandDividerWidthPx: $brandDividerWidthPx
  ) {
    giveawayId
    eventId
    name
    broadcasterUserIds
    entryCommand
    winnerCount
    alternateCount
    excludeBroadcaster
    excludeModerators
    rulesUrl
    sponsorName
    prizeName
    prizeImageUrl
    brandLogoUrl
    brandText
    backgroundImage
    backgroundImageFit
    titleText
    openCtaText
    entrantsLabel
    openFooterText
    upcomingHeadline
    upcomingCtaText
    closedHeadline
    closedSubhead
    closedBody
    closedFooterText
    endedHeadline
    congratsText
    endedFooterText
    rulesLabel
    legalText
    fontKey
    textColor
    background
    borderColor
    borderWidth
    cornerRadius
    winnerOutlineColor
    accentBackground
    accentTextColor
    titleFontKey
    textFontKey
    captionFontKey
    subtitleFontKey
    prizeImageRadius
    prizeImageBorderWidth
    prizeImageBorderColor
    prizeImageWidthPx
    countDividerEnabled
    countDividerColor
    countDividerWidthPx
    brandDividerEnabled
    brandDividerColor
    brandDividerWidthPx
    status
    entrantCount
    startedAt
    closedAt
    publishedAt
    createdAt
    version
    hasDraw
    winners {
      twitchUserId
      login
      displayName
      rank
      kind
      disqualifiedAt
      disqualifiedReason
    }
    draw {
      drawId
      methodVersion
      eligibleCount
      targetRound
      fallbackUsed
      drawnAt
      shortPool
      requestedWinnerCount
      requestedAlternateCount
      winners {
        twitchUserId
        login
        displayName
        rank
        kind
        disqualifiedAt
        disqualifiedReason
      }
      alternates {
        twitchUserId
        login
        displayName
        rank
        kind
        disqualifiedAt
        disqualifiedReason
      }
      disqualifications {
        twitchUserId
        reason
        byUserId
        at
        promotedTwitchUserId
      }
    }
  }
}
